import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { addBreadcrumb } from 'actions/other';
import { setViewAndResetState } from 'actions/organisation';
import { ORGANISATIONPEOPLEVIEW } from 'components/Organisation/helpers';
import { Avatar } from 'components/common';
import useOrgProfileLink from 'hooks/useOrgProfileLink';

const LogoImage = styled.img`
  margin-right: 25px;
`;

function Logo({
  organisationName,
  superOrganisationId,
  superOrganisationLogoUrl,
}) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const orgProfileLink = useOrgProfileLink();

  const setOrgProfileView = () => {
    dispatch(setViewAndResetState(ORGANISATIONPEOPLEVIEW));
  };

  const onLogoClick = () => {
    setOrgProfileView();
    dispatch(
      addBreadcrumb({
        name: document.title.split(' | ')[0],
        path: pathname,
        id: Math.floor(Math.random() * Math.floor(10000)),
      })
    );
  };

  const makeImageUrl = () => {
    const s3Bucket = process.env.REACT_APP_PORTAL_CDN || 'dev-scil-portal-cdn';
    return `https://${s3Bucket}.s3.eu-west-1.amazonaws.com/${superOrganisationLogoUrl}_40x40`;
  };

  const addDefaultSrc = ev => {
    const s3Bucket = process.env.REACT_APP_PORTAL_CDN || 'dev-scil-portal-cdn';
    var defaultSrc = `https://${s3Bucket}.s3.eu-west-1.amazonaws.com/images/logos/superorganisation/Avatar_40_40.png`;
    if (ev.target.src !== defaultSrc) {
      ev.target.src = defaultSrc;
    }
  };

  return (
    <RouterLink to={orgProfileLink(superOrganisationId)} onClick={onLogoClick}>
      {superOrganisationLogoUrl ? (
        <LogoImage
          src={makeImageUrl()}
          alt={organisationName}
          onError={addDefaultSrc}
        />
      ) : (
        <Avatar icon='company' size={'small'} />
      )}
    </RouterLink>
  );
}

Logo.propTypes = {};

export default Logo;
